import { render } from "./template-dialog.vue?vue&type=template&id=5ed909a8&scoped=true&ts=true"
import script from "./template-dialog.vue?vue&type=script&lang=ts"
export * from "./template-dialog.vue?vue&type=script&lang=ts"

import "./template-dialog.vue?vue&type=style&index=0&id=5ed909a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed909a8"]])

export default __exports__